import React, { useState } from 'react';
import styles from '../../styles/modules/common/media.module.scss';
import Config from '../../config';
import UIDropdown from '../common/ui-components/input/UIDropdown/UIDropdown';


const list = [
    {
        "text": "2020-2021",
        "value": "2020-2021",
        "key": "1",

    },
]

const reports = [
    {
        "title": "Onsitego 2020-2021 Investor Report",
        "path": "/static/pdfs/investor-report.pdf#toolbar=0",
        "year": "2020-2021"
    }
]


const ReportList = () => {
    const [year, setYear] = useState<any>({
        "text": "2020-2021",
        "value": "2020-2021",
        "key": "1",
    })

    const handleYearChange = (e) => {
        setYear({
            "text": e["text"],
            "value": e["value"],
            "key": e["key"]
        })
    }

    return (
        <div className={`container ${styles.investorlist}`}>
            <div className={`row ${styles.investorcard}`}>
                <p>Select Year</p>
                <UIDropdown options={list} placeholder='Select Year' value={year.value} selected_option={year} onChange={(e) => { handleYearChange(e) }} />
            </div>
            {
                reports.filter(item => year.value === item.year).map((item) => {
                    return (
                        <div className={`row ${styles.investorcard}`}>
                            <div className={`col-12 col-md-8 col-lg-8 ${styles.heading}`}>
                                <h6>{item.title}</h6>
                            </div>
                            <div className={`col-12 col-md-4 col-lg-4 ${styles.view}`}>
                                <a href={`${Config.ASSETPREFIX_PATH}${item.path}`}>View</a>
                            </div>
                        </div>
                    )
                }
                )

            }
        </div>
    )
}

export default ReportList;